import { useEffect } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { css } from '@emotion/react';
import { FormState, Quality } from '@definitions';
import { CommonFilters, StateCheckbox } from '@components/inputs';
import { useAppTranslation } from '@hooks';
import { GetFormsPayloadType } from '@api';
import { Button, Form, FormItem } from 'common-components';
import { FiltersDrawer, FiltersDrawerFooter } from '@components/display';
import { SelectManagers } from '@views/shared/manager';

type FiltersFormPropsType = {
  visible: boolean
  onFiltersChange?: (filters: GetFormsPayloadType) => void
  onClose?: () => void
  initValues?: GetFormsPayloadType
};

const FiltersForm = ({ visible, onClose, onFiltersChange, initValues }: FiltersFormPropsType) => {
  const { control, handleSubmit, reset } = useForm<GetFormsPayloadType>({
    defaultValues: { model: {}, ...(initValues || {}) },
  });
  const { translate } = useAppTranslation();

  useEffect(() => {
    reset(initValues);
  }, [initValues]);

  const onSubmit = (data: GetFormsPayloadType) => {
    onFiltersChange && onFiltersChange(data);
    onClose && onClose();
  };

  return (
    <FiltersDrawer open={visible} onClose={onClose}>
      <Form onFinish={handleSubmit(onSubmit)} css={$form}>
        <CommonFilters<GetFormsPayloadType> control={control} />

        <Controller
          name={'model.state'}
          control={control}
          render={({ field }) => (
            <FormItem label={translate('common.state')}>
              <StateCheckbox
                values={FormState}
                labelTxKey={'formState'}
                preset={'form-state'}
                inputProps={{
                  onChange: field.onChange,
                  value: field.value,
                }}
              />
            </FormItem>
          )}
        />
        <Controller
          name={'model.idUser'}
          control={control}
          render={({ field }) => (
            <FormItem label={translate('common.managers')}>
              <SelectManagers onChange={field.onChange} value={field.value} />
            </FormItem>
          )}
        />

        <Controller
          name={'model.quality'}
          control={control}
          render={({ field }) => (
            <FormItem label={translate('common.quality')}>
              <StateCheckbox
                values={Quality}
                labelTxKey={'quality'}
                preset={'quality'}
                inputProps={{
                  onChange: field.onChange,
                  value: field.value,
                }}
              />
            </FormItem>
          )}
        />

        <FiltersDrawerFooter>
          <Button onClick={() => reset()}>{translate('common.buttons.cancel')}</Button>
          <Button type="primary" htmlType="submit">
            {translate('common.buttons.apply')}
          </Button>
        </FiltersDrawerFooter>
      </Form>
    </FiltersDrawer>
  );
};

const $form = css`
  display: flex;
  flex-direction: column;
  width: 100%;
`;


export default FiltersForm;
